import { createContext, useContext, useState, useEffect } from 'react'
import Header from '../components/Header'
import LoadingIcon from '../ui_icons/loading.svg'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

const AuthContext = createContext()

function Auth({ children }) {
  const [user, setUser] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      setUser(user)
      setLoading(false)
    })
  }, [])

  function handleLogout() {
    if (window.confirm('Are you sure you want to log out?')) {
      firebase.auth().signOut()
    }
  }

  async function handleLogin(email, password) {
    setLoading(true)
    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(e => {
        setError(e.message)
        setLoading(false)
      })
  }

  function AuthWrapper({ children }) {
    return (
      <AuthContext.Provider value={{ user, handleLogout, handleLogin }}>
        {children}
      </AuthContext.Provider>
    )
  }
  function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    useEffect(() => {
      function submitOnEnter(event) {
        if (event.key === 'Enter') {
          handleLogin(email, password)
        }
      }
      window.addEventListener('keypress', submitOnEnter)
      return () => window.removeEventListener('keypress', submitOnEnter)
    })

    return (
      <>
        <Header />
        <main id="login">
          <h2>
            Welcome to
            <br />
            <span className="red">TED</span> Stage Notifier
          </h2>
          <p>
            Stage Notifier is a tool for TED staff to remotely communicate with
            speakers while they're on stage.
          </p>

          <p>Log in to continue.</p>

          <section>
            <div className="input-wrapper">
              <label>Email</label>
              <input
                type="email"
                placeholder="name@ted.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>

            <div className="input-wrapper">
              <label>Password</label>
              <input
                type="password"
                placeholder="********"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
          </section>

          {error ? <p className="red">{error}</p> : null}

          <button
            disabled={!email || !password}
            className={loading ? 'loading' : null}
            onClick={() => handleLogin(email, password)}
            data-mixpanel-component="login-button"
          >
            Log in
          </button>

          <aside>Need access? Contact the Tech Team for permissions.</aside>
        </main>
      </>
    )
  }

  function Loading() {
    return (
      <>
        <Header />
        <main id="loading">
          <img src={LoadingIcon} alt="Loading" />
          <p>Loading...</p>
        </main>
      </>
    )
  }

  return (
    <AuthWrapper>
      {user ? children : loading ? <Loading /> : <Login error={error} />}
    </AuthWrapper>
  )
}

const useAuth = () => useContext(AuthContext)

export { Auth, AuthContext, useAuth }
